// Team.js

import React from 'react';

import TitleField from '../text/TitleField';
import TextField from '../text/TextField';

import { StaggerGroup, StaggerItem } from '../motion/Stagger';

import '../../styles/team/TeamHero.css';


const TeamHero = () => {



    return (
        <>
            <StaggerGroup as="div" className='team-title-container' staggerChildren={0.18} delayChildren={0.1}>
                <StaggerItem as="div" className='product-eyebrow-label'>
                    OUR TEAM
                </StaggerItem>
                <StaggerItem as="div" className='team-tile-advertisment'>
                    <TitleField title={<>Small Team <span className="team-hero-title-highlight">Niche</span> Solutions</>}
                        bold={true} level={1} fontSize='3rem' />
                </StaggerItem>

                <StaggerItem as="div" className='team-paragraph-advertisment'>
                    <TextField text="We're two developers with a simple goal: create modern, reliable software that helps Resident Associations work better and serve their communities."
                        fontColor='#898989' />
                </StaggerItem>
            </StaggerGroup>
        </>
    )
}


export default TeamHero;